import { type PermissionsType } from "../../Enum/PermissionsType"
import { usePermission } from "../../hooks/Permissions/usePermission"
import { TitlePageResponsiveIcon } from "../Titles/Titles"

type CanViewProps = {
  permission: PermissionsType
  children: React.ReactNode
  showMessage?: boolean
}

export function CanView({ permission, children, showMessage = false }: CanViewProps) {
  const allowed = usePermission(permission)

  if (!allowed) {
    return showMessage ? <TitlePageResponsiveIcon /> : null
  }

  return <>{children}</>
}
